import React from 'react';

interface EyeIconProps {
  size?: number;
  className?: string;
  color?: string;
}

const EyeIcon: React.FC<EyeIconProps> = ({
  size = 14,
  className = '',
  color = '#0A0A0A'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_305_5273)">
        <path
          d="M1.20284 7.20297C1.15423 7.072 1.15423 6.92793 1.20284 6.79697C1.67634 5.64888 2.48006 4.66724 3.51213 3.97649C4.54419 3.28574 5.75812 2.91699 7.00001 2.91699C8.2419 2.91699 9.45583 3.28574 10.4879 3.97649C11.52 4.66724 12.3237 5.64888 12.7972 6.79697C12.8458 6.92793 12.8458 7.072 12.7972 7.20297C12.3237 8.35105 11.52 9.33269 10.4879 10.0234C9.45583 10.7142 8.2419 11.0829 7.00001 11.0829C5.75812 11.0829 4.54419 10.7142 3.51213 10.0234C2.48006 9.33269 1.67634 8.35105 1.20284 7.20297Z"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_305_5273">
          <rect width="14" height="14" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default EyeIcon;
